import { ReactFlowProvider } from '@xyflow/react'
import { GeckoNotificationProvider } from 'features/notifications'
import React from 'react'
import { PfdNode } from 'types'

import { ProcessFlowDiagramBuilderDataLayer } from './contexts/ProcessFlowDiagramBuilderContext'
import { ProcessFlowDiagramBuilder } from './ProcessFlowDiagramBuilder'

interface ProcessFlowDiagramProps {
  siteID: string
  diagramID: string
  viewOnly?: boolean
  onNodeClick?: (node: PfdNode) => void
  selectedNodeByData?: { key: string; value: string }
  renderNodePopup?: (node: PfdNode, onClose: () => void) => React.ReactNode
  reactFlowClassName?: string
  hideHeader?: boolean
  hideMenuBar?: boolean
  showBackgroundToggle?: boolean
  labelOverrides?: Record<string, string>
  colorOverrides?: Record<string, string>
}

export const ProcessFlowDiagram: React.FC<ProcessFlowDiagramProps> = ({
  siteID,
  diagramID,
  viewOnly = false,
  onNodeClick,
  selectedNodeByData,
  renderNodePopup,
  reactFlowClassName,
  hideHeader = false,
  hideMenuBar = false,
  showBackgroundToggle = false,
  labelOverrides,
  colorOverrides,
}) => {
  return (
    <>
      <GeckoNotificationProvider>
        <ReactFlowProvider>
          <ProcessFlowDiagramBuilderDataLayer
            siteID={siteID}
            diagramID={diagramID}
            viewOnly={viewOnly}
            onNodeClick={onNodeClick}
            selectedNodeByData={selectedNodeByData}
            renderNodePopup={renderNodePopup}
            labelOverrides={labelOverrides}
            colorOverrides={colorOverrides}>
            <ProcessFlowDiagramBuilder
              viewOnly={viewOnly}
              hideHandleConnectionIndicators={viewOnly}
              reactFlowClassName={reactFlowClassName}
              hideHeader={hideHeader}
              hideMenuBar={hideMenuBar}
              showBackgroundToggle={showBackgroundToggle}
            />
          </ProcessFlowDiagramBuilderDataLayer>
        </ReactFlowProvider>
      </GeckoNotificationProvider>
    </>
  )
}
